import { Outlet } from "react-router";

export const Properties = () => {
  return <Outlet />;
};
